import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Page } from '@/model/document2/page/page';
import { Design } from '@/model/document2/page/surface/design/design';

// デザインの削除コマンド
export class DeleteDesignCommand implements ICommandBase
{
    private position! : number;
    private page! : Page;
    private isReverse! : boolean;
    private doneCallback! : () => void;

    private orgDesign : Design | null;

    constructor(position : number, page : Page, isReverse : boolean, doneCallback : () => void)
    {
        this.position = position;
        this.page = page;
        this.isReverse = isReverse;
        this.doneCallback = doneCallback;
        
        // コピー先の元のデザインを保持(存在しない場合はnull)
        this.orgDesign = page.getSurface(this.isReverse).getDesign(position);
    }

    private get surface() { return this.page.getSurface(this.isReverse); }

    public do() : void
    {
        // 削除
        this.surface.removeDesign(this.position);
        
        this.doneCallback();
    }

    public undo() : void
    {
        if(this.orgDesign != null)
        {
            // 元のデザインを削除した場所にセット。
            this.surface.setDesign(this.position, this.orgDesign);
        }
        
        this.doneCallback();
    }

    public redo() : void
    {
        // 削除
        this.surface.removeDesign(this.position);

        this.doneCallback();
    }
}
